import {HASHES, QUERY_KEYS, ROUTES} from '@/helpers'

export default {
    beforeCreate() {
        this.HASHES = HASHES
        this.QUERY_KEYS = QUERY_KEYS
        this.ROUTES = ROUTES
    }
}